<template >
    <div>
     <!-- ********************************************************************************************** -->
<template>
            <v-row justify="center">
              <v-dialog
                v-model="dialogoUpload"
                persistent
                max-width="450px"
              >
                <v-card elevation="8">
                  <v-card-title style="background-color:#006699;">
                    <span class="text-h5" style="color:white;">Carregar foto <v-icon color="white">mdi-camera</v-icon> </span><br>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="2" md="2" ></v-col>
                        <v-col cols="12" sm="10" md="10" >
                          <v-col md="8">
                          <div>
                            <div class="content">
                              <section class="cropper-area">
                                <div class="img-cropper">
                                  <vue-cropper v-if="imgSrc !== ''"
                                    ref="cropper"
                                    :aspect-ratio="20 / 20"
                                    :src='imgSrc'
                                    preview=".preview"
                                  />
                                </div>
                              </section>
                           
                        </div>
                      </div>
                          </v-col>
              </v-col>
                </v-row>
                      <hr>
                      <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red" small dark @click="reset()">Cancelar</v-btn>
                      <v-btn v-if="imgSrc !== ''" small @click.prevent="cropImage"  dark color="#006699">Salvar<v-icon small dark >mdi-content-cut</v-icon></v-btn>
                    </v-card-actions>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
          </template>
<!-- ******************************************************************************************************* -->
    </div>
</template>
<script>
import axios from '../../../../plugins/axios'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  components: {
    VueCropper
  },
  name: 'carregarFoto',
  props: ['usuario', 'eventPhoto'],

  data: () => ({
    dialogoUpload: false,
    imgSrc: ''
  }),

  computed: {
    Instituicao () {
      return ls.get('i_id')
    },
    role () {
      return ls.get('role')
    }
  },

  created () {
    this.setImage(this.eventPhoto)
  },

  methods: {
    setImage (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        Swal.fire({ icon: 'warning', title: '', text: 'Por favor selecione uma imagem' })
      } else {
        if (typeof FileReader === 'function') {
          this.sufixOriginalname = file.name
          this.dialogoUpload = true
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imgSrc = event.target.result
            // rebuild cropperjs with the updated source
            // this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          Swal.fire({ icon: 'warning', title: '', text: 'Ficheiro não suportado' })
        }
      }
    },
    cropImage () {
      try {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
        this.savephoto()
      } catch (error) {
        this.dialogoUpload = false
        this.imgSrc = ''
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao cortar a foto' })
      }
    },

    flipX () {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    flipY () {
      const dom = this.$refs.flipY
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleY(scale)
      dom.setAttribute('data-scale', scale)
    },
    getCropBoxData () {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData () {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move (offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    reset () {
      try {
        this.$refs.cropper.reset()
        this.cropImg = null
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro' })
      } finally {
        this.dialogoUpload = false
        this.imgSrc = ''
      }
    },
    rotate (deg) {
      this.$refs.cropper.rotate(deg)
    },
    setCropBoxData () {
      if (!this.data) return
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data))
    },
    setData () {
      if (!this.data) return
      this.$refs.cropper.setData(JSON.parse(this.data))
    },
    zoom (percent) {
      this.$refs.cropper.relativeZoom(percent)
    },
    
    async savephoto () {
      try {
        this.$store.state.isloading = true
        let fileName = this.usuario.idPessoa + '.png'
        let params = { fileName: fileName, ficheiro: this.cropImg, sigla: ls.get('sigla') + '/usuarios' }
        let result = await axios({ method: 'post', url: ls.get('urlFoto') + 'uploadImg', data: params }).then(res => res.data)

        if (result && result.affectedRows > 0) {
          this.$store.state.isloading = false
          Swal.fire({ icon: 'success', title: '', text: 'Operação realizada com sucesso' })
        }
      } catch (error) {
        this.$store.state.isloading = false
        this.dialogoUpload = false
        this.imgSrc = ''
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao realizar a operação' })
      } finally {
        this.$store.state.isloading = false
        this.dialogoUpload = false
        this.imgSrc = ''
        this.fecharComponente()
      }
    },
    fecharComponente () {
      this.$emit('fecharComponente', false)
    }
  }
}
</script>
<style>

</style>
